import React, { useEffect, useState } from "react";
import { Box, Flex, Spinner, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import GButton from "components/ui/button/Button";
import LimitsToCustomerTagsModal from "./modals/LimitsToCustomerTagsModal";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import LimitsCustomerTagsTable from "./LimitsCustomerTagsTable";
import { getDiscountLimitCustomerTags } from "../services/discountsLimitCustomerTagsService";
import DeleteAppliesModal from "./modals/DeleteAppliesModal";

const LimitsToCustomerTags = () => {
  const id = useParams();
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const [showCustomerTags, setShowCustomerTags] = useState(false);
  const [showDeleteCustomerTagModal, setShowDeleteCustomerTagModal] = useState(null);

  const customerTagsofDiscount = useSelector(
    (state) => state.discountsLimitCustomerTags
  );

  console.log("customerTagsofDiscount", customerTagsofDiscount);

  useEffect(() => {
    dispatch(getDiscountLimitCustomerTags(id.id));
  }, [dispatch, id]);

  return (
    <Box>
      <Flex
        alignItems="center"
        justifyContent="space-between"
        gap={2}
        flexWrap="wrap"
        mb={6}
      >
        <Text color="text" textTransform="capitalize">
          {t("pages.discounts.limits_to-customer-tags")}
        </Text>

        <GButton
          title={t("pages.discounts.add_customer_tags")}
          bg="light"
          color="text"
          fontSize="14px"
          border="1px solid"
          borderColor="border"
          hover={{ bg: "light" }}
          onClick={() => setShowCustomerTags(true)}
        />
      </Flex>

      {customerTagsofDiscount.isLoading ? (
        <Spinner />
      ) : customerTagsofDiscount.data?.length === 0 ? (
        <Flex
          p={4}
          bg="white"
          alignItems="center"
          justifyContent="center"
          color="text"
          textTransform="capitalize"
          boxShadow="0rem 0.3125rem 0.3125rem 0rem rgba(82, 63, 105, 0.05)"
          borderRadius={6}
        >
          {t("pages.branches.no_data")}
        </Flex>
      ) : customerTagsofDiscount.data?.length > 0 ? (
        <LimitsCustomerTagsTable
          customerTagsOfDisc={customerTagsofDiscount.data}
          handleDelete={(customerTag) => setShowDeleteCustomerTagModal(customerTag)}
        />
      ) : (
        <Flex
          p={4}
          bg="white"
          alignItems="center"
          justifyContent="center"
          color="text"
          textTransform="capitalize"
          boxShadow="0rem 0.3125rem 0.3125rem 0rem rgba(82, 63, 105, 0.05)"
          borderRadius={6}
        >
          {t("pages.branches.no_data")}
        </Flex>
      )}

      {showCustomerTags && (
        <LimitsToCustomerTagsModal onClose={() => setShowCustomerTags(false)} />
      )}

      {showDeleteCustomerTagModal && (
        <DeleteAppliesModal
          id={showDeleteCustomerTagModal}
          onClose={() => setShowDeleteCustomerTagModal(null)}
          type="CusomerTag"
        />
      )}
    </Box>
  );
};

export default LimitsToCustomerTags;
